//(function () {
//    $('.store-selector').on('change', function() {
//        location.href = this.value + location.pathname + location.search;
//    });
//})();

(function () {
    const customSelectTrigger = document.querySelector('.store-selector .custom-select-trigger');
    const customOptionsContainer = document.querySelector('.store-selector .custom-options');
    const customOptions = Array.from(document.querySelectorAll('.store-selector .custom-option'));
    const selectElement = document.querySelector('.store-selector .store-selector-actual');

    customOptions.sort((a, b) => {
        return parseInt(a.getAttribute('data-position')) - parseInt(b.getAttribute('data-position'));
    });

    customOptions.forEach(option => {
        customOptionsContainer.appendChild(option);
    });

    function updateCustomTrigger(value, shortCountryCode, flagSrc) {
        customSelectTrigger.querySelector('.selected-country-code').textContent = shortCountryCode;
        customSelectTrigger.querySelector('.selected-flag').src = flagSrc;
        selectElement.value = value;
    }

    customSelectTrigger.addEventListener('click', function () {
        this.classList.toggle('open');
        customOptionsContainer.classList.toggle('open');
    });

    customOptions.forEach(option => {
        option.addEventListener('click', function () {
            const value = this.getAttribute('data-value');
            const shortCountryCode = this.getAttribute('data-short-country-code');
            const flagSrc = this.getAttribute('data-flag');
            updateCustomTrigger(value, shortCountryCode, flagSrc);
            location.href = value + location.pathname + location.search;
            customOptionsContainer.classList.remove('open');
            customSelectTrigger.classList.remove('open');
        });

        if (option.getAttribute('data-selected') === 'true') {
            const value = option.getAttribute('data-value');
            const shortCountryCode = option.getAttribute('data-short-country-code');
            const flagSrc = option.getAttribute('data-flag');
            updateCustomTrigger(value, shortCountryCode, flagSrc);
        }
    });

    document.addEventListener('click', function (e) {
        if (!customSelectTrigger.contains(e.target)) {
            customSelectTrigger.classList.remove('open');
            customOptionsContainer.classList.remove('open');
        }
    });

    window.addEventListener('scroll', function () {
        customSelectTrigger.classList.remove('open');
        customOptionsContainer.classList.remove('open');
    });

    const selectedOption = customOptions.find(option => option.getAttribute('data-selected') === 'true');
    if (selectedOption) {
        const value = selectedOption.getAttribute('data-value');
        const shortCountryCode = selectedOption.getAttribute('data-short-country-code');
        const flagSrc = selectedOption.getAttribute('data-flag');
        updateCustomTrigger(value, shortCountryCode, flagSrc);
    }
})();